"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeAutosubmit = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changeAutosubmit = exports.changeAutosubmit = (0, _actionGenerator.actionGenerator)(_types.ETwoFactorPhoneActionTypes.AutosubmitChanged);